import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { MENU_OPTIONS} from '../../../layout/Layout/menu-options'
import MenuCard from '../../../layout/Navigation/menu-card'
import { accountsSelector, getMenuListSelector } from '../../../selectors'

const menuDetails =  MENU_OPTIONS.filter(e => e.key === "TRANSFER")[0].children


export default function Transfers() {
  const history = useHistory()
  const accounts = useSelector(accountsSelector) || []
  const menuConfig = useSelector(getMenuListSelector)['TRANSFER'] || {}

  return (
    <LayoutWithAccountCard breadCumKey='TRANSFERS'>
      <Row>
        {Object.keys(menuConfig).length>0 && menuDetails.map((option, index) => (
          <>
          {menuConfig[option.key] && 
              <MenuCard
                handleMenuCallback={() => history.push(option.link)}
                icon={option.icon}
                name={option.title}
                description={option.desc}
                key={index}
              />
           }
           </>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
